module.exports = __webpack_public_path__ + "img/cooperate_yh_01@2x.93525414.png";